import { configureStore } from '@reduxjs/toolkit'
import { config } from './config/config'

import {
  middleware as apiMiddleware,
  reducer as apiReducer,
  reducerPath as apiReducerPath
} from './energy/api'
import { whiteLabelApi } from './broadband/white-labeling.api'
import { reducer as preSwitchReviewReducer } from './energy/components/PreSwitchCollapse/PreSwitchCollapse'
import { reducer as addressesReducer } from './energy/middleware/addresses.slice'
import { reducer as energyReducer } from './energy/middleware/energySlice'
import { reducer as quotesReducer } from './energy/steps/SortAndFilter'
import { analyticsMiddleware } from './middleware/analyticsMiddleware'
import { reducer as analyticsReducer } from './middleware/analyticsSlice'

export * from './energy/middleware/addresses.slice'

const store = configureStore({
  reducer: {
    [apiReducerPath]: apiReducer,
    analytics: analyticsReducer,
    energy: energyReducer,
    quotes: quotesReducer,
    preSwitchReview: preSwitchReviewReducer,
    addresses: addressesReducer,
    [whiteLabelApi.reducerPath]: whiteLabelApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      apiMiddleware,
      analyticsMiddleware(config),
      whiteLabelApi.middleware
    ),
  devTools: true
})

export default store
